import PropTypes from 'prop-types';
import React from 'react';

/**
 * @typedef {Object} ChatTypingIndicatorProps
 * @property {boolean} isTyping
 */

/**
 * Typing indicator shown while waiting for a simulated bot response.
 * @component
 * @param {ChatTypingIndicatorProps} props
 * @returns {JSX.Element|null}
 */
export default function ChatTypingIndicator({ isTyping }) {
  if (!isTyping) {
    return null;
  }

  return (
    <div
      aria-hidden="true"
      className="va-chatbot-typing-indicator"
      data-testid="chat-typing-indicator"
      role="presentation"
    >
      <span
        aria-hidden="true"
        className="va-chatbot-typing-indicator__dots"
        role="presentation"
      />
    </div>
  );
}

ChatTypingIndicator.propTypes = {
  isTyping: PropTypes.bool.isRequired,
};
